import { ca } from '@cian/analytics';

export const trackBubbleShow = (chatId: string, bubbleType: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Show_sopr',
    label: 'Bubble',
    page: {
      extra: {
        chat_id: chatId,
        bubble_type: bubbleType,
      },
    },
  });
};
